module.exports = __webpack_public_path__ + "img/steam36x36.16f5792a.png";